<template>
	<!-- 完结更多 -->
	<div>
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="backUrl">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">完结</p>
				</div>
			</div>
		</van-sticky>
		<div>
			<van-tabs v-model="active" animated swipeable>
				<van-tab v-for="(item,index) in tabbarLists" :title="item">
					<!-- 言情 -->
					<div class="xiandaiyanqingBox" v-show="index == 0 ? true : false">
						<div class="blockBox">
							<div v-if="ranking_qywj.length==0 ? true : false" style="text-align: center;margin-top: 100px;">
								<img src="../../assets/img/data_null.png" width="100" alt="">
							</div>
							<div v-else class="blockLeft" v-for="(item,index) in ranking_qywj" :key="index">
								<div class="book_Img">
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
								</div>
								<div class="blockBookInfo">
									<div class="bookName">
										<!-- <span v-for="(bookName,nameIndex) in item.name" v-if="nameIndex <= 8">{{bookName}}</span> -->
										<span class="bookTxtBox" v-if="item.name">
											<van-notice-bar scrollable :text="item.name"></van-notice-bar>
										</span>
										<span class="bookTxtBox" v-else>
											<van-notice-bar scrollable :text="item.name"></van-notice-bar>
										</span>
									</div>
									<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p></div>
									<p class="bookType">{{item_vip.original_name != undefined ? item_vip.original_name : '无'}}-{{item_vip.appetency_name != undefined  ? item_vip.appetency_name : '无'}}-{{item_vip.epoch_name != undefined  ? item_vip.epoch_name : '无'}}-{{item_vip.type_name != undefined  ? item_vip.type_name : '无'}}</p>
									<div class="introduction">
										<p>{{item.introduce}}</p>
									</div>
									<div class="book_button">
										<button v-for="i in item.lable_list">{{i.name}}</button>

									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 纯爱 -->
					<div class="xiandaiyanqingBox" v-show="index == 1 ? true : false">
						<div class="blockBox">
							<div v-if="ranking_cawj.length==0 ? true : false" style="text-align: center;margin-top: 100px;">
								<img src="../../assets/img/data_null.png" width="100" alt="">
							</div>
							<div v-else class="blockLeft" v-for="(item,index) in ranking_cawj" :key="index">
								<div class="book_Img">
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
								</div>
								<div class="blockBookInfo">
									<div class="bookName">
									<span class="bookTxtBox" v-if="item.name">
										<van-notice-bar scrollable :text="item.name"></van-notice-bar>
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.name"></van-notice-bar>
									</span>
										
									</div>
									<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p></div>
									<!-- <p class="bookType">{{item.original_name}}-{{item.perspective_name}}-{{item.style_name}}-{{item.type_name}}</p> -->
									<p class="bookType">{{item_vip.original_name != undefined ? item_vip.original_name : '无'}}-{{item_vip.appetency_name != undefined  ? item_vip.appetency_name : '无'}}-{{item_vip.epoch_name != undefined  ? item_vip.epoch_name : '无'}}-{{item_vip.type_name != undefined  ? item_vip.type_name : '无'}}</p>
									<div class="introduction">
										<p>{{item.introduce}}</p>
									</div>
									<div class="book_button">
										<button v-for="i in item.lable_list">{{i.name}}</button>

									</div>
								</div>
							</div>
						</div>
					</div>
					<!--衍生 -->
					<div class="xiandaiyanqingBox" v-show="index == 2 ? true : false">
						<div class="blockBox">
							<div v-if="ranking_yswj.length==0 ? true : false" style="text-align: center;margin-top: 100px;">
								<img src="../../assets/img/data_null.png" width="100" alt="">
							</div>
							<div v-else class="blockLeft" v-for="(item,index) in ranking_yswj">
								<div class="book_Img">
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
								</div>
								<div class="blockBookInfo">
									<div class="bookName">
									<span class="bookTxtBox" v-if="item.name">
										<van-notice-bar scrollable :text="item.name"></van-notice-bar>
									</span>
									<span class="bookTxtBox" v-else>
										<van-notice-bar scrollable :text="item.name"></van-notice-bar>
									</span>
									</div>
									<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p></div>
									<!-- <p class="bookType">{{item.original_name}}-{{item.perspective_name}}-{{item.style_name}}-{{item.type_name}}</p> -->
									<p class="bookType">{{item_vip.original_name != undefined ? item_vip.original_name : '无'}}-{{item_vip.appetency_name != undefined  ? item_vip.appetency_name : '无'}}-{{item_vip.epoch_name != undefined  ? item_vip.epoch_name : '无'}}-{{item_vip.type_name != undefined  ? item_vip.type_name : '无'}}</p>
									<div class="introduction">
										<p>{{item.introduce}}</p>
									</div>
									<div class="book_button">
										<button v-for="i in item.lable_list">{{i.name}}</button>

									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 言情半价 -->
					<div class="xiandaiyanqingBox" v-show="index == 3 ? true : false">
						<div class="blockBox">
							<div v-if="ranking_qybj.length==0 ? true : false" style="text-align: center;margin-top: 100px;">
								<img src="../../assets/img/data_null.png" width="100" alt="">
							</div>
							<div v-else class="blockLeft" v-for="(item,index) in ranking_qybj">
								<div class="book_Img">
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
								</div>
								<div class="blockBookInfo">
									<div class="bookName">
										<span class="bookTxtBox" v-if="item.name">
											<van-notice-bar scrollable :text="item.name"></van-notice-bar>
										</span>
										<span class="bookTxtBox" v-else>
											<van-notice-bar scrollable :text="item.name"></van-notice-bar>
										</span>
									</div>
									<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p></div>
									<!-- <p class="bookType">{{item.original_name}}-{{item.perspective_name}}-{{item.style_name}}-{{item.type_name}}</p> -->
									<p class="bookType">{{item_vip.original_name != undefined ? item_vip.original_name : '无'}}-{{item_vip.appetency_name != undefined  ? item_vip.appetency_name : '无'}}-{{item_vip.epoch_name != undefined  ? item_vip.epoch_name : '无'}}-{{item_vip.type_name != undefined  ? item_vip.type_name : '无'}}</p>
									<div class="introduction">
										<p>{{item.introduce}}</p>
									</div>
									<div class="book_button">
										<button v-for="i in item.lable_list">{{i.name}}</button>

									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 纯爱半价-->
					<div class="xiandaiyanqingBox" v-show="index == 4 ? true : false">
						<div class="blockBox">
							<div v-if="ranking_cabj.length==0 ? true : false" style="text-align: center;margin-top: 100px;">
								<img src="../../assets/img/data_null.png" width="100" alt="">
							</div>
							<div v-else class="blockLeft" v-for="(item,index) in ranking_cabj">
								<div class="book_Img">
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
								</div>
								<div class="blockBookInfo">
									<div class="bookName">
										<span class="bookTxtBox" v-if="item.name">
											<van-notice-bar scrollable :text="item.name"></van-notice-bar>
										</span>
										<span class="bookTxtBox" v-else>
											<van-notice-bar scrollable :text="item.name"></van-notice-bar>
										</span>
									</div>
									<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p></div>
									<!-- <p class="bookType">{{item.original_name}}-{{item.perspective_name}}-{{item.style_name}}-{{item.type_name}}</p> -->
									<p class="bookType">{{item_vip.original_name != undefined ? item_vip.original_name : '无'}}-{{item_vip.appetency_name != undefined  ? item_vip.appetency_name : '无'}}-{{item_vip.epoch_name != undefined  ? item_vip.epoch_name : '无'}}-{{item_vip.type_name != undefined  ? item_vip.type_name : '无'}}</p>
									<div class="introduction">
										<p>{{item.introduce}}</p>
									</div>
									<div class="book_button">
										<button v-for="i in item.lable_list">{{i.name}}</button>

									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 衍生半价 -->
					<div class="xiandaiyanqingBox" v-show="index == 5 ? true : false">
						<div class="blockBox">
							<div v-if="ranking_ysbj.length==0 ? true : false" style="text-align: center;margin-top: 100px;">
								<img src="../../assets/img/data_null.png" width="100" alt="">
							</div>
							<div v-else class="blockLeft" v-for="(item,index) in ranking_ysbj">
								<div class="book_Img">
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
								</div>
								<div class="blockBookInfo">
									<div class="bookName">
										<span class="bookTxtBox" v-if="item.name">
											<van-notice-bar scrollable :text="item.name"></van-notice-bar>
										</span>
										<span class="bookTxtBox" v-else>
											<van-notice-bar scrollable :text="item.name"></van-notice-bar>
										</span>
									</div>
									<div class="auther"><span>{{item.author}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p></div>
									<!-- <p class="bookType">{{item.original_name}}-{{item.perspective_name}}-{{item.style_name}}-{{item.type_name}}</p> -->
									<p class="bookType">{{item_vip.original_name != undefined ? item_vip.original_name : '无'}}-{{item_vip.appetency_name != undefined  ? item_vip.appetency_name : '无'}}-{{item_vip.epoch_name != undefined  ? item_vip.epoch_name : '无'}}-{{item_vip.type_name != undefined  ? item_vip.type_name : '无'}}</p>
									<div class="introduction">
										<p>{{item.introduce}}</p>
									</div>
									<div class="book_button">
										<button v-for="i in item.lable_list">{{i.name}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				active: 0,
				tabbarLists: ["言情", "纯爱", "衍生", "言情半价", "纯爱半价", "衍生半价"],
				bookInfoList: [],
				ranking_qywj: [], //言情完结
				ranking_cawj: [], //纯爱完结
				ranking_yswj: [], //衍生完结
				ranking_qybj: [], //言情半价
				ranking_cabj: [], //纯爱半价
				ranking_ysbj: [], //衍生半价

			}
		},
		created() {
			this.get_ranking_qywj(); //言情
			this.get_ranking_cawj(); //纯爱
			this.get_ranking_yswj(); //衍生
			this.get_ranking_qybj(); //言情半价
			this.get_ranking_cabj(); //纯爱半价
			this.get_ranking_ysbj(); //衍生半价
			this.active = this.$route.query.active
		},
		methods: {
			backUrl() {
				this.$router.push('/bookcity')
			},
			//言情
			get_ranking_qywj() {
				this.$axios.post(this.$api.ranking_qywj).then(res => {
					console.log(res, '言情')
					if (res.status == 200) {
						this.ranking_qywj = res.data.data.list
					}

				})
			},
			//纯爱
			get_ranking_cawj() {
				this.$axios.post(this.$api.ranking_cawj).then(res => {
					console.log(res, '纯爱')
					if (res.status == 200) {
						this.ranking_cawj = res.data.data.list
					}

				})
			},
			//衍生
			get_ranking_yswj() {
				this.$axios.post(this.$api.ranking_yswj).then(res => {
					console.log(res, '衍生')
					if (res.status == 200) {
						this.ranking_yswj = res.data.data.list
					}

				})
			},
			//言情半价
			get_ranking_qybj() {
				this.$axios.post(this.$api.ranking_qybj).then(res => {
					console.log(res, '言情半价')
					if (res.status == 200) {
						this.ranking_qybj = res.data.data.list
					}

				})
			},
			//纯爱半价
			get_ranking_cabj() {
				this.$axios.post(this.$api.ranking_cabj).then(res => {
					console.log(res, '纯爱半价')
					if (res.status == 200) {
						this.ranking_cabj = res.data.data.list
					}

				})
			},
			//衍生半价
			get_ranking_ysbj() {
				this.$axios.post(this.$api.ranking_ysbj).then(res => {
					console.log(res, '衍生半价')
					if (res.status == 200) {
						this.ranking_ysbj = res.data.data.list
					}

				})
			},
		}
	}
</script>


<style>
	.van-tabs__line {
		background-color: transparent;
	}

	.van-tab--active {
		color: #ff4081;
		transform: scale(1.1);
		font-weight: 600;
	}
</style>
<style lang="less" scoped>
	// 头部
	.headerBox {
		height: 160px;
		// background-color: #ff4081;
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;

		/*no*/
		.headerQuery {
			margin-top: 70px;
			padding: 0 16px;
			position: relative;
			display: flex;
			width: 100%;
			height: 90px;
			line-height: 90px;
			color: #000;


			.arrImg {
				img {
					width: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 0px;
				}
			}

			.header_titile {
				flex: 1;
				text-align: center;
				font-size: 34px;
				/*px*/
			}
		}

	}

	.xiandaiyanqingBox {

		//列表数据
		.blockBox {
			overflow: hidden;
			position: relative;
			background-color: #fff;
			padding: 0px 16px;

			.blockLeft {
				display: flex;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.book_Img {
					// width: 138px;
					height: 240px;

					img {
						float: left;
						width: 155px;
						height: 240px;
						/*px*/
						-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
					}
				}

				.blockBookInfo {
					margin-left: 20px;
					flex: 1;
					font-size: 26px;
					/*px*/
					line-height: 30px;

					.auther {
						color: #000;
						font-size: 26px;
						/*px*/
						opacity: 0.6;
						/*px*/
						p {
							display: inline-block;
							float: right;
							font-weight: 400;
						
							span {
								margin-left: 8px;
								color: #000;
								font-size: 26px;
								/*px*/
							}
						
							// .wanjie {
							// 	color: #ff0000;
							// }
						
							// .txtGreen {
							// 	color: #5ca615;
							// }
						}
					}
					
					.bookName {
						// line-height: 40px;
						padding-bottom: 20px;
						font-size: 30px;
						/*px*/
						// font-weight: 600;
						.bookTxtBox {
							width: calc(100vw - 260px);
							font-size: 30px;
							/*px*/
							color: #000;
							overflow: hidden;
							display: inline-block;
							.van-swipe .van-swipe__track--vertical .van-swipe-item {
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
						
							.van-notice-bar {
								background: rgba(0, 0, 0, 0);
								color: #000;
								height: 30px;
								padding: 0;
							}
						}
					}
					

					.bookType,
					.introduction {
						padding-top: 20px;
						color: #000;
						opacity: 0.6;
						font-size: 24px;
						/*px*/
					}

					.introduction {
						width: 60vw;
						padding-top: 15px;

						p {
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
					}

					.book_button {
						margin-top: 15px;
						align-items: center;

						button {
							border: 0;
							outline: none;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							line-height: 36px;
							/*px*/
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							font-size: 24px;
							/*px*/
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							margin-bottom: 10px;
						}

						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}

		}
	}
</style>
